// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// utilities
import _ from 'lodash';

// components
import TextArea from '../../../../../../common/components/c_TextArea';
import FlatButton from '../../../../../../common/components/c_FlatButton';

// get validations
import {getSchema} from '../../../../../../models/contactNote';

const validationObj = getSchema();

export default class AddNoteForm extends Component {
  static propTypes = {
    contactId: PropTypes.number.isRequired,
    contactStatusId: PropTypes.number.isRequired,
    submitNote: PropTypes.func.isRequired,
    category: PropTypes.string.isRequired,
    staticData: PropTypes.object,
    value: PropTypes.string.isRequired
  }

  state = {
    noteDropDownVal: null, // some statuses will have corresponding dropdowns
    note: this.props.value || '',
    errorCount: 0
  }

  onChange(prop, event, value) {
    this.setState(_.merge({}, this.state, {
      [prop]: value || event.target.value
    }));

  }

  onErrorChange = changeInt => {
    this.setState(_.merge(this.state, {errorCount: this.state.errorCount + changeInt}));
  };

  onSave() {
    this.props.submitNote({
      contactId: this.props.contactId,
      contactStatusId: this.props.contactStatusId,
      category: this.props.category,
      note: this.state.note,
      type: 'note'
    });
    this.clear();
  }

  clear() {
    this.setState(_.merge({}, {
      noteDropDownVal: null,
      note: ''
    }));
  }

  render() {
    const contactStatusKeyById = _.keyBy(this.props.staticData.contactStatus, 'id');

    return (
      <form className='event-form notes-form'>
        <TextArea
          className='note-textarea'
          data-id='Note Text'
          style={{
            minHeight: '145px'
          }}
          description={`${_.get(contactStatusKeyById, `${this.props.contactStatusId}.name`)} Notes`}
          onChange={this.onChange.bind(this, 'note')}
          onErrorChange={this.onErrorChange}
          placeholder='Note contents...'
          value={this.state.note}
          validation={validationObj.note}
        />
        <FlatButton disabled={!this.state.note || this.state.errorCount > 0}
                    onClick={::this.onSave}
                    className='save-btn'
                    label='Save'
                    disabledStyle={{
                      color: '#979797',
                      backgroundColor: '#fff'
                    }}
                    labelStyle={{
                      width: 'auto',
                      padding: 0
                    }}/>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/Events/AddNoteForm/index.js